import {
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild
} from "@angular/core";
import {PageFooterControlDirective} from "../page-footer-control.directive";
import {Page, PageAlignment, PageGeometry, PageLayout} from "../../orchestration/page";
import {NavigationService} from "../../orchestration/navigation.service";
import {ContentMessageComponent} from "../../notification/message/message.component";
import {IconButtonType} from "../../buttons/icon-button/icon-button";

@Component({
    selector: "woa-modal-page-layout",
    templateUrl: "./modal-page-layout.component.html",
    providers: [{provide: PageLayout, useExisting: ModalPageLayoutComponent}]
})
export class ModalPageLayoutComponent extends PageLayout implements OnInit {
    PageAlignment = PageAlignment;
    IconButtonType = IconButtonType;

    // header options
    @Input() showHeader: boolean = true;
    @Input() showCloseButton: boolean = true;
    @Input() showCancelLink: boolean = false;
    @Input() closeButtonAlignment: PageAlignment = PageAlignment.RIGHT;
    @Input() showRefreshButton: boolean = false;
    @Input() showSubtitle: boolean = true;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() translationParams: any = {};

    // page background options
    @Input() showBackground: boolean = true;
    @Input() backgroundColorPair: string = "standard-page";

    // page content options
    @Input() contentText: string;
    @Input() showContent: boolean = true;
    @Input() padWhenNoContent: boolean = true;

    // footer options
    @Input() showFooter: boolean = true;
    @Input() showFooterBorder: boolean;
    @Input() footerControlOrientation: "horizontal" | "vertical" = "horizontal";
    @Input() allowSafeArea: boolean = true;

    @Output() onRefresh: EventEmitter<void> = new EventEmitter();

    @ViewChild("scroller", {read: ElementRef}) public scrollerElementRef: ElementRef;

    @ContentChildren(ContentMessageComponent) contentMessages: QueryList<ContentMessageComponent>;
    @ContentChildren(PageFooterControlDirective) footerControls: QueryList<any>;

    private _customGeometry: PageGeometry;

    constructor(public page: Page,
                private navigationService: NavigationService) {
        super();
    }

    @Input()
    set customGeometry(customGeometry: PageGeometry) {
        if (this.page.containerComponentRef && customGeometry !== this._customGeometry) {
            this._customGeometry = customGeometry;
            this.page.containerComponentRef.instance.geometry$.next(this._customGeometry);
        }
    }

    get showLeftCloseButton(): boolean {
        return this.showCloseButton && this.closeButtonAlignment === PageAlignment.LEFT;
    }

    get showRightCloseButton(): boolean {
        return this.showCloseButton && this.closeButtonAlignment === PageAlignment.RIGHT;
    }

    get showLeftRefreshButton(): boolean {
        return this.showRefreshButton && (this.showRightCloseButton || this.showCancelLink);
    }

    get showRightRefreshButton(): boolean {
        return this.showRefreshButton && !(this.showRightCloseButton || this.showCancelLink);
    }

    get backgroundColorPairClass(): string {
        return this.showBackground ? "theme-" + this.backgroundColorPair + "-color-pair" : undefined;
    }

    ngOnInit(): void {
        this.page.containerComponentRef && this.page.containerComponentRef.instance.geometry$.next(this._customGeometry);
    }

    async close(): Promise<any> {
        return this.page && this.navigationService.dismissPage(this.page);
    }
}



// WEBPACK FOOTER //
// ./src/app/page-layout/modal-page-layout/modal-page-layout.component.ts